import { render, staticRenderFns } from "./NoAccess.vue?vue&type=template&id=37a6a84e"
import script from "./NoAccess.ts?vue&type=script&lang=ts&external"
export * from "./NoAccess.ts?vue&type=script&lang=ts&external"
import style0 from "./NoAccess.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports